import * as React from 'react';
import { Link } from 'react-router-dom';

interface Breadcrumb {
  link: string;
  text: string;
}

interface Props {
  items: Breadcrumb[];
  className?: string;
}

export default class Breadcrumbs extends React.Component<Props> {
  static defaultProps = {
    items: [],
    className: '',
  };

  render() {
    return (
      <section className={`breadcrumb ${this.props.className}`}>
        <ul>
          {this.props.items.map((item, index) => (
            <li
              key={index}
              className={
                index === this.props.items.length - 1 ? 'is-active' : ''
              }
            >
              <Link to={item.link}>{item.text}</Link>
            </li>
          ))}
        </ul>
      </section>
    );
  }
}
